import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {defaultDialogSettings, defaultSettings, MaterializedViewSettings} from "../../../../core/models";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FormGroupRecord} from '../../../../core/types/form.type';

@Component({
    selector: 'app-materialized-view-settings',
    templateUrl: './materialized-view-settings.component.html',
    styleUrls: ['./materialized-view-settings.component.scss'],
    standalone: false
})
export class MaterializedViewSettingsComponent implements OnInit, OnChanges {
  value: MaterializedViewSettings = {...defaultSettings.materialized_view}
  protected form: FormGroupRecord<MaterializedViewSettings> = new FormGroup({
    schedule: new FormControl<number>(defaultSettings.materialized_view.schedule, [Validators.required]),
    project_list_period: new FormControl<number>(defaultSettings.materialized_view.project_list_period, [Validators.required])
  });

  @Input() settings: MaterializedViewSettings;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      this.settings = changes['settings'].currentValue;
      this.setSettings();
    }
  }

  setSettings(): void {
    const disabled = this.form.disabled;
    this.form.enable();
    this.value = {
      ...defaultDialogSettings,
      ...this.settings
    };
    if (this.settings?.schedule) {
      this.form.controls.schedule.setValue(this.settings.schedule)
    }
    if (this.settings?.project_list_period) {
      this.form.controls.project_list_period.setValue(this.settings.project_list_period)
    }
    if (disabled) {
      this.form.disable();
    }
  }

  edit(): void {
    this.form.enable();
  }

  cancel(): void {
    this.setSettings();
    this.form.disable();
  }

  save(): void {
    this.form.disable();
    this.saveSettings.next(this.form);
  }
}
